import * as React from "react";

import {useSelector} from "react-redux";
import {State} from "../../reducer";
import {ParamsMarqueCollection} from "../../types";
import {Grid} from "@mui/material";
import {NBComplementOperator} from "./NBComplementOperator";
import TextField from "@mui/material/TextField";
import {resetMarqueEditorialeParameter, updateMarqueEditorialeParameter} from "../../action/parametrageAction";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useAppDispatch } from "../../store";



interface Props {
    marqueId: string,
    collectionId?: string
}

export const NBComplement: React.FC<Props> = ({marqueId, collectionId}) => {

    const defaultParameter = {
        marque: marqueId,
        collection: collectionId ?? ''
    } as ParamsMarqueCollection
    const dispatch = useAppDispatch();

    const parameter = useSelector(({parametrage}: State) => parametrage.currentParamsMarqueCollection ?? defaultParameter)
    return (<Grid container spacing={2}>
            <Grid>
                Nombre de Compléments
            </Grid>
            <Grid>
                <NBComplementOperator value={parameter.operatorComplement ?? ''} defaultParams={defaultParameter}/>
            </Grid>

            <Grid>
                <TextField
                    type="number" InputProps={{
                    inputProps: {
                        max: 300, min: 0
                    }
                }}
                    style={{width: '75px'}}
                    value={parameter.nbrComplementExpected ?? ''} onChange={(event) => {
                    const newParam = {
                        ...defaultParameter,
                        nbrComplementExpected: parseInt(event.target.value),
                        operatorComplement: parameter.operatorComplement
                    }
                    dispatch(updateMarqueEditorialeParameter(newParam))
                }
                }
                />
            </Grid>
            {parameter.operatorComplement &&
            <Grid>
                <IconButton color="primary" aria-label="Effacer" component="span" size={"small"}
                            onClick={() => {
                                dispatch(resetMarqueEditorialeParameter(
                                    {
                                        ...parameter,
                                        nbrComplementExpected: null,
                                        operatorComplement: null
                                    }
                                ))
                            }}>
                    <ClearIcon/>
                </IconButton>
            </Grid>
            }
        </Grid>
    )
};
